import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import RenderFields from "../../../../../../components/Modals/ModalFields/RenderFields";
import { selectAllCompanies } from "../../../../../../redux/mgmtCo/managementSlice";
import { selectAllCustomers } from "../../../../../../redux/customers/customerSlice";

const RenderFieldsBuildings = (props) => {
  const {
    fields,
    formData,
    handleChange,
    fieldTransformers = {},
    dropdownLists,
    ...rest
  } = props;

  const managementCompanies = useSelector(selectAllCompanies);
  const customers = useSelector(selectAllCustomers);

  const modifiedFields = fields.map((field) => {
    if (field.key === "managementID") {
      // Management field logic.
      const customer = customers.find(
        (customer) => customer.customerID === formData.customerID
      );
      const managementCompanyId = customer?.managementID || null;
      const managementCompany = managementCompanies.find(
        (company) => company.managementId === managementCompanyId
      );
      return {
        ...field,
        forceReadOnly: true,
        value: managementCompany?.companyName || "-",
      };
    } else if (field.key === "customerID") {
      return {
        ...field,
        forceReadOnly: true,
      };
    } else if (field.key === "salesRep") {
      // Build options for sales representatives.
      const options = (
        Array.isArray(dropdownLists?.allSalesPersons)
          ? dropdownLists.allSalesPersons
          : []
      ).map((person) => ({
        value: person.id,
        label: `${person.firstName} ${person.lastName}` || "-",
      }));
      return {
        ...field,
        type: "select", // override type to force dropdown rendering
        options,
      };
    } else if (field.key === "taxDetailID") {
      // Build dropdown options from allTaxDetails prop.
      const options = (
        Array.isArray(dropdownLists?.allTaxDetails)
          ? dropdownLists.allTaxDetails
          : []
      ).map((detail) => ({
        value: detail.id,
        label: detail.description || "-",
      }));
      return {
        ...field,
        type: "select",
        options,
      };
    } else if (field.key === "agencyID") {
      const options = (
        Array.isArray(dropdownLists?.allAgencies)
          ? dropdownLists.allAgencies
          : []
      ).map((agency) => ({
        value: agency.agencyId,
        label: agency.agencyName || "-",
      }));
      return {
        ...field,
        type: "select",
        options,
      };
    }

    return field; // Return any other fields unchanged.
  });

  const customFieldTransformers = {
    ...fieldTransformers,
    managementID: (value) => {
      const customer = customers.find(
        (customer) => customer.customerID === formData.customerID
      );
      const managementCompanyId = customer?.managementID || null;
      const managementCompany = managementCompanies.find(
        (company) => company.managementId === managementCompanyId
      );
      return managementCompany ? managementCompany.companyName : value;
    },
    customerID: (value) => {
      const customer = customers.find(
        (customer) => customer.customerID === value
      );
      return customer ? customer.customerName : value;
    },
  };

  return (
    <RenderFields
      fields={modifiedFields}
      formData={formData}
      handleChange={handleChange}
      fieldTransformers={customFieldTransformers}
      {...rest}
    />
  );
};

RenderFieldsBuildings.propTypes = {
  fields: PropTypes.array.isRequired,
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  fieldTransformers: PropTypes.object,
  dropdownLists: PropTypes.object,
};

export default RenderFieldsBuildings;
